module.exports = __webpack_public_path__ + "static/media/phone_mb.eb287150.svg";